import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import ForgotPassword from "../pages/Authentication/ForgetPassword";
import ResetPassword from "../pages/Authentication/ResetPassword";
import Signup from "../pages/Authentication/Signup";
import ListAgents from "../pages/Agents/listAgents";
import CreateNewAgent from "../pages/Agents/CreateNewAgent";
import ListPrompts from "../pages/Prompts/listPrompts";
import CreateNewPrompt from "../pages/Prompts/CreateNewPrompt";
import UpdateAgent from "../pages/Agents/UpdateAgent";
import MakeCall from "../pages/MakeCall/MakeCall";
import ListCalls from "../pages/MakeCall/ListCalls";
import CreateNewCampaign from "../pages/Campaigns/CreateNewCampaign";
import ListCampaigns from "../pages/Campaigns/ListCampaign";
import UpdateCampaign from "../pages/Campaigns/UpdateCampaign";
import Configrations from "../pages/Configrations";
import PricingPlans from "../pages/Pricing";
import Billing from "../pages/Billing";
import StripeContainer from "../pages/Checkout/StripeContainer";
import Thankyou from "../pages/Checkout/Thankyou";
import OnboardingPage from "../pages/GetStarted/Onboarding";
import DuplicateCampaign from "../pages/Campaigns/DuplicateCampaign";
import WebhookConfig from "../pages/Configrations/WebhookConfig";
import PostCallWebhookConfig from "../pages/Configrations/PostCallWebhook";
import WidgetEmbed from "../pages/Widget/WidgetEmbed";
import ListChats from "../pages/MakeCall/ListChat";
import ListTestCalls from "../pages/MakeCall/ListTestCalls";



export const DefaultRoute = (props) => {
	return <Navigate to="/dashboard" />;
	// return <Navigate to="/call-list" />;
};
const publicRoutes = [
    { path: "/login", element: Login },
    { path: "/signup", element: Signup },
    { path: "/reset-password/:token", element: ResetPassword },
    { path: "/forgot-password", element: ForgotPassword },
    // { path: "/widget", element: WidgetEmbed },
]
const adminRoutes = [
    { path: "/Logout", element: Logout, allowedInTrail: true },
    // { path: "/dashboard", element: Dashboard, allowedInTrail: false },
    { path: "/agents", element: ListAgents, allowedInTrail: false },
    { path: "/create-new-agent", element: CreateNewAgent, allowedInTrail: false },
    { path: "/update-agent/:id", element: UpdateAgent, allowedInTrail: false },
    { path: "/prompts", element: ListPrompts, allowedInTrail: false },
    { path: "/create-new-prompt", element: CreateNewPrompt, allowedInTrail: false },
    { path: "/make-call", element: MakeCall, allowedInTrail: false },
    { path: "/call-list", element: ListCalls, allowedInTrail: false },
    { path: "/chat-list", element: ListChats, allowedInTrail: false },
    { path: "/test-call-logs", element: ListTestCalls, allowedInTrail: false },
    { path: "/campaigns", element: ListCampaigns, allowedInTrail: false },
    { path: "/create-new-campaign", element: CreateNewCampaign, allowedInTrail: false },
    { path: "/update-campaign/:id", element: UpdateCampaign, allowedInTrail: false },
    { path: "/duplicate-campaign", element: DuplicateCampaign, allowedInTrail: false },
    { path: "/configuration", element: Configrations, allowedInTrail: false },
    { path: "/configuration/webhook", element: WebhookConfig, allowedInTrail: false },
    { path: "/configuration/post-webhook", element: PostCallWebhookConfig, allowedInTrail: false },
    { path: "/pricing-plans", element: PricingPlans, allowedInTrail: true },
    { path: "/billing", element: Billing, allowedInTrail: false },
    { path: "/checkout", element: StripeContainer, sidebar: false, allowedInTrail: true },
    { path: "/thankyou", element: Thankyou, sidebar: false, allowedInTrail: true },
    { path: "/", element: DefaultRoute, allowedInTrail: false },
    { path: "/dashboard", element: Dashboard, allowedInTrail: false },
    { path: "/get-started", element: OnboardingPage, allowedInTrail: false },
]

export { publicRoutes, adminRoutes };